import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

export default function NotFoundPage() {
  return (
    <div className="app">
      <Header />
      <main className="section">
        <div className="container">
          <div className="card">
            <h2>Page not found</h2>
            <p className="card-body" style={{ marginTop: '0.75rem' }}>
              The page you’re looking for doesn’t exist.
            </p>
            <Link className="btn btn-primary" to="/" style={{ marginTop: '1rem' }}>
              Go home
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

